<template>
  <!-- <myNav title="往期活动"></myNav> -->
  <div class="allContent">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, index) in state.topicList"
        :key="item + 'comment'"
      >
        <template #value>
          <div class="topicInfo" @click="goTopicDetail(item.id)">
            <img :src="item.pic1" alt="" />
            <div class="info">
              <h3>{{ item.post_title }}</h3>
              <p>参与人数：{{ item.count }}</p>
              <p>活动时间：{{ item.post_date.slice(0, 10) }}</p>
            </div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script setup>
import { ref, onMounted, onActivated, reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getTopicList } from "../../api/yzCommunity";
import { getQueryString } from "../../utils/location";

const router = useRouter();
const store = useStore();

const state = reactive({
  loading: false,
  finished: false,
  topicList: [],
});

onActivated(() => {
  state.topicList = [];
  pagecode = 1;
  totalpage = 1;
  state.loading = false;
  state.finished = false;
  isFetchList = false;
  getTopicListInfo();
});

const onLoad = async () => {
  if (isFetchList) {
    return;
  }
  await getTopicListInfo();
};

var pagecode = 1;
var totalpage = 1;

var isFetchList = false;

const getTopicListInfo = async () => {
  isFetchList = true;
  const res = await getTopicList({
    uid: getQueryString("uid"),
    pagecode: pagecode,
  });
  if (res.data.code == 1) {
    if (pagecode > totalpage) {
      state.finished = true;
      return;
    }
    state.topicList = state.topicList.concat(res.data.data.lists);
    pagecode++;
    isFetchList = false;
  }
  state.loading = false;

  // console.log("往期话题数据---------------------", state.topicList);
};

const goTopicDetail = (data) => {
  router.push({
    path: "/topic",
    query: {
      topicId: data,
      uid:getQueryString("uid"),
      mobile:getQueryString('mobile')
    },
  });
};
</script>

<style src="../../styles/removeVantcell.css"></style>
<style scoped>
:deep(.van-nav-bar) {
  background: #fff;
}
.nav {
  background-color: #fff;
  margin-bottom: 0;
}
.allContent {
  height: 100vh;
  background-color: #f7f8fa;
  padding: 30px 32px;
}
.topicInfo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.topicInfo img {
  width: 336px;
  height: 200px;
  margin-right: 28px;
  border-radius: 16px;
}
.topicInfo .info {
  width: 320px;
}
.topicInfo .info h3 {
  color: #333;
  max-height: 78px;
  font-size: 28px;
  margin-bottom: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.topicInfo .info p {
  font-size: 24px;
  color: #8F9197;
}
</style>
